import React, {useState, useEffect} from "react";
import Loader from "react-loader-spinner";              
import {useSelector, useDispatch} from 'react-redux';           
import * as userAuthActions from '../../Redux/Actions/user';
import DropDown from "../Ui/DropDown";

const Login = ({history}) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // const [rememberMe, setRememberMe] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const [role, setRole] = useState('SUPERADMIN');
    const [roleOption, setRoleOption] = useState([]); 

    useEffect(() => {
        setRoleOption([
            { label: "Admin", value: "SUPERADMIN" },
            { label: "Call Center Agent", value: "CALLCENTERSUPPORT" },
            { label: "Sub Admin", value: "SUBADMIN" },
            { label: "Finance", value: "FINANCE" },
            { label: "Tracking", value: "TRACKING" }
        ]);
    }, []);

    const handleUserLogin = () => {
        setButtonLoading(true);
        let payload = { 
            userName: email, 
            password: password,
            role: role, 
        };
        if((email !== '') && (password !== '')){
            userAuthActions.userLogin(payload).then(res => {
                if(res && res.status === 200){
                    let jwtResponse = parseJwt(res.data.data.token);
                    document.cookie = `jwt=${res.data.data.token}; path=/; max-age=86400; secure; SameSite=Strict`;
                    dispatch(userAuthActions.userData(jwtResponse));
                    if(jwtResponse.Role === 'CALLCENTERSUPPORT'){
                        history.push('/customer_job_reports');
                    }
                    else{
                        history.push('/dashboard');
                    }
                    
                    setButtonLoading(false);
                }
            }).catch(err => {
                setErrorMsg(err.response?.data?.message);
                setButtonLoading(false);
            });
        }else{
            setButtonLoading(false);
            setErrorMsg('Enter the correct user name and password');
        }
    }

    const parseJwt = (token) => {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);             
    };

    return(
        <div className="account-body d-flex flex-column justify-content-center vw-100">
            <div className="logo logo-admin position-absolute" style={{marginLeft: '60px', top: 0}}>
                <img src="/Assets/aamer_logo.jpg" width="150px" height="auto" alt="logo" className="auth-logo" />
            </div>
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                            <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <h4 className="mt-3 mb-1 fw-semibold text-white font-18">Back Office</h4> 
                                            <p className="mb-0" style={{color: '#b71c1c'}}>Sign in to continue to back office</p>  
                                        </div>
                                    </div>
                                    <div className="card-body p-0">
                                        <ul className="nav-border nav nav-pills">
                                            <li className="nav-item">
                                                <p className="nav-link active fw-semibold m-0 c-pointer ms-2" style={{lineHeight: '33px'}}>Log In</p>
                                            </li>
                                        </ul>
                                        <div className="tab-content">
                                            <div className="tab-pane active p-3" role="tabpanel">                                        
                                                <div className="form-horizontal auth-form">
                                                    <div className="form-group mb-2">
                                                        <label className="form-label" htmlFor="role">Role</label>
                                                        <DropDown value={roleOption.label}  placeholder={"Admin"} options={roleOption} onChange={e => {setRole(e.value)}} />                                   
                                                    </div>

                                                    <div className="form-group mb-2">
                                                        <label className="form-label" htmlFor="username">Username</label>
                                                        <div className="input-group">                                                                                         
                                                            <input type="text" className="form-control" name="username" placeholder="Enter username" autocomplete="new-username" value={email} onChange={e => {setEmail(e.target.value); setErrorMsg('')}} />
                                                        </div>                                    
                                                    </div>
                        
                                                    <div className="form-group mb-2">
                                                        <label className="form-label" htmlFor="userpassword">Password</label>                                            
                                                        <div className="input-group">                                  
                                                            <input type="password" className="form-control" name="password" placeholder="Enter password" autocomplete="new-password" value={password} onKeyPress={e => (e.charCode === 13) ? handleUserLogin() : ''} onChange={e => {setPassword(e.target.value); setErrorMsg('')}} />
                                                        </div>                          
                                                    </div>
                                                    {(errorMsg || ((email === '') || (password === ''))) && <p className="text-danger mt-2 text-center font-weight-bold">{errorMsg}</p>}
                                                    <div className="form-group row justify-content-end mb-3">
                                                        {/* <div className="col-sm-6">
                                                            <div className="custom-control custom-switch switch-success d-flex align-items-center">
                                                                <input type="checkbox" className="custom-control-input" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} />
                                                                <label className="form-label text-muted m-0 ms-1" htmlFor="customSwitchSuccess">Remember me</label>
                                                            </div>
                                                        </div> */}
                                                        {/* <div className="col-sm-6 text-end">
                                                            <p className="text-muted font-13 c-pointer" onClick={() => history.push('/forgot-password')}><i className="dripicons-lock"></i> Forgot password?</p>
                                                        </div>  */}
                                                    </div>
                        
                                                    <div className="form-group mb-0 row">
                                                        <div className="col-12">
                                                            <button className="btn btn-primary w-100 waves-effect waves-light d-flex align-items-center justify-content-center" type="button" disabled={buttonLoading} onClick={handleUserLogin}>
                                                                Log In {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                                            </button>
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Aamer © 2021</span>                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;